import React, {Component} from "react"
import { ThemeToggler } from 'gatsby-plugin-dark-mode'

import "../styles/navbar.scss"
import "../styles/include-media.scss"
import "bulma/css/bulma.css";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = { active: false };
  }
  handleClick = () => {
    this.setState({ active: !this.state.active });
   };
  render() {
  return (
    <div className="section">
      <div className="container">
        <div className="navbar-wrapper">
          <div className="name">
            Home
          </div>
          <span
            role="button"
            className={
              "navbar-burger burger " + (this.state.active ? "is-active" : "")
            }
            aria-label="menu"
            aria-expanded="false"
            onClick={this.handleClick}
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </span>

          <div className={"links-wrapper"+ (this.state.active ? "is-active" : "")}>
            <ul>
            <li><a href = '/about'>About</a></li>
            <li><a href = '/publications'>Publications</a></li>
            <li><a href = '/members'>Downloads</a></li>
            <li><a href = '/about'>Feedback</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
}

export default Navbar;

// <li><button onClick={() => scrollTo("#about")}>About</button></li>